import { message, Upload } from 'hljd'
import React, { Component, Fragment } from 'react'
import Style from './style.module.less'
import { observer } from 'mobx-react'

/**
 * @description: 多图片上传组件，使用hljd组件upload实现
 * @param {*}
 * @return {*}
 */

@observer
export default class extends Component {
  render() {
    const onChange = e => {
      // onChange 抛出裁剪参数问题
      const { onChange } = this.props
      const data = []
      for (let i = 0; i < e.length; i++) {
        const { width, height, url: mediaPath, response } = e[i]
        data.push({ kind: 1, content: { width, height, mediaPath, response } })
      }
      onChange(data)
    }
    // 初始化value回填
    const { value } = this.props
    const result = []
    for (let i = 0; i < value?.length; i++) {
      const { content } = value[i]
      const { width, height, mediaPath: url, response } = content
      result.push({ width, height, url, type: 'image', response })
    }
    const beforeUpload = async (file, fileList) => {
      const { width, height } = await Upload.checkSizeSync(file)
      if (file.size > 1024 * 1024 * 10) {
        message.warning('图片大小不能超过10M')
        return Promise.reject(file)
      } else if (width < 540) {
        message.warning('图片宽度不能小于540px')
        return Promise.reject(file)
      } else if (height < 540) {
        message.warning('图片高度不能小于540px')
        return Promise.reject(file)
      } else {
        return Promise.resolve(file)
      }
    }
    return (
      <Fragment>
        <div className={Style.container}>
          <Upload
            cropModalNode={{
              title: '裁剪图片'
            }}
            onChange={e => onChange(e)}
            beforeUpload={val => beforeUpload(val)}
            width={120}
            height={160}
            value={result}
            multiple
            sortable
            max={9}
            clipable
            aspect={[
              { title: '3:4', value: 3 / 4 },
              { title: '1:1', value: 1 / 1 },
              { title: '4:3', value: 4 / 3 }
            ]}
          />
        </div>
        <div style={{ margin: '4px 0 0 0' }}>
          <p className={Style.text_desc}>
            1、图片建议上传3-9张，比例为3:4，支持jpg、jpeg、png等多种格式，点击图片可进行裁剪
          </p>
          <p className={Style.text_desc}>
            2、拖动图片可调整顺序，其中第一张图片将作为作品的封面图
          </p>
        </div>
        {/* 新增预览图模块 */}
        {value &&
          value.length > 0 && (
            <div className={Style.preview}>
              <div className={Style.title}>方形封面预览</div>
              <img className={Style.img} src={value[0].content.mediaPath} />
              <div className={Style.text}>主要用于商家列表中作品的展示</div>
            </div>
          )}
      </Fragment>
    )
  }
}
